export default function() {}



//////////////////
// WEBPACK FOOTER
// ./packages/element/node_modules/d3-shape/src/noop.js
// module id = 12
// module chunks = 0